import React from 'react'
import { useTranslation } from 'react-i18next';

const AllModels = () => {
    const { t } = useTranslation();

  return (
    <div className='all-models container'>
        <div className='sedans'>
            <h1>{t("sedan")}</h1>
            <a href="/elantra"><img src='https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/elantra-cn7-2023-quater-view-cars.png'alt='elantra'/>Elantra</a>
            <a href="/sonata"><img src='https://www.hyundai.com/content/dam/hyundai/kz/ru/data/vehicle-thumbnail/product/sonata-2023/default/new_sonata_672x364px.png' alt='sonata'/>Sonata</a>
        </div>
        <div className='sedans'>
            <h1>{t("suv")}</h1>
            <a href="/tucson"><img src='https://www.hyundai.com/content/dam/hyundai/kz/ru/data/vehicle-thumbnail/product/tucson-2021/default/tucson_672x364px-pc.png'alt='tucson'/>Tucson</a>
            <a href="/santafe"><img src='https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/santa-fe-mx5-2023/santafe-mx5-2023-quater-view-suv.png' alt='santafe'/>SantaFe</a>
        </div>
        <div className='sedans'>
            <h1>{t("eco")}</h1>
            <a href="/ionic"><img src='https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/all-vehicles/ioniq5-ne-quater-view-gravity-gold-matte.png'alt='ioniq'/>IONIQ 5</a>
        </div>
        <div className='sedans'>
            <h1>{t("commercial")}</h1>
            <a href="/staria"><img src='https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/mpv/staria-full-page/hybrid/staria-us4-quater-view-hybrid.png'alt='ioniq'/>STARIA</a>
        </div>
      
    </div>
  )
}

export default AllModels
